import React, { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";

export default function ConstructionBanner() {
  // Start OPEN by default
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // If you *never* want it to reappear after closing (even on refresh),
    // keep this check. If you want it to show every page load, delete this block.
    const dismissed = localStorage.getItem("constructionBannerDismissed");
    if (dismissed) setIsVisible(false);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem("constructionBannerDismissed", "true");
  };

  if (!isVisible) return null;

  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-[9999] bg-gradient-to-r from-yellow-500/95 via-orange-500/95 to-red-500/95 backdrop-blur-sm shadow-lg">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-start justify-between gap-4">
            <div className="flex items-start gap-3 flex-1 min-w-0">
              <AlertTriangle className="h-5 w-5 text-white flex-shrink-0 mt-0.5 animate-pulse" />
              <div className="min-w-0">
                <p className="text-sm sm:text-base font-semibold text-white">
                  Website Under Construction
                </p>
                <p className="text-xs sm:text-sm text-white/90 mt-0.5">
                  This site is in active development. All profile data, reviews,
                  posts, likes, and other user content may be reset or removed at
                  any time without notice.
                </p>

                {/* “Entice to close to continue browsing” */}
                <p className="text-[11px] sm:text-xs text-white/95 mt-2">
                  Close this to continue browsing →
                </p>
              </div>
            </div>

            <button
              onClick={handleDismiss}
              className="flex-shrink-0 inline-flex items-center gap-2 rounded-lg bg-white/15 px-3 py-2 hover:bg-white/25 transition-colors"
              aria-label="Close banner and continue"
            >
              <span className="text-xs font-semibold text-white">Continue</span>
              <X className="h-4 w-4 text-white" />
            </button>
          </div>
        </div>
      </div>

      {/* Spacer to push content down while visible */}
      <div className="h-[96px]" aria-hidden="true" />
    </>
  );
}
